import { FieldItem, Lot } from 'models';

interface LotsFields {
  baseInfo: FieldItem;
  spaceInfo: FieldItem;
  sizeInfo: FieldItem;
  ownerInfo: FieldItem<Lot>;
  buildInfo: FieldItem;
}

// id - field path
// format - string, date, boolean
// options? - [true, false]

export const lotsFields: LotsFields = {
  baseInfo: {
    title: 'G_GeneralInformation',
    fieldsList: [
      {
        id: 'Cooperative.Name',
        format: 'string',
        key: 'Name',
      },
      {
        id: 'Lessor.Name',
        format: 'string',
        key: 'LessorName',
      },
      {
        id: 'OfficialLotID',
        format: 'string',
        key: 'OfficialLotID',
      },
    ],
  },
  ownerInfo: {
    title: 'G_OwnerInformation',
    fieldsList: [
      {
        id: 'RentedOwned',
        format: 'string',
        key: 'IsRentedOrOwned',
        render: (lot) => lot.RentedOwned?.Label ?? '--',
      },
      {
        id: 'ReclaimOfLotShare.Label',
        format: 'string',
        key: 'ReclaimOfLotShareLabel',
      },
      {
        id: 'RentAmount',
        format: 'string',
        key: 'RentAmount',
      },
      {
        id: 'RentFeeAdjustmentBasis',
        format: 'string',
        key: 'RentFeeAdjustmentBasis',
      },
      {
        id: 'RentContractEndDate',
        format: 'date',
        key: 'RentContractEndDate',
      },
    ],
  },
  spaceInfo: {
    title: 'G_LocationInformation',
    fieldsList: [
      {
        id: 'CountyOrCity',
        format: 'string',
        key: 'CountyOrCity',
      },
      {
        id: 'Block',
        format: 'string',
        key: 'Block',
      },
      {
        id: 'NeihgborhoodOrVillage',
        format: 'string',
        key: 'NeihgborhoodOrVillage',
      },
      {
        id: 'LotOrEstate',
        format: 'string',
        key: 'LotOrEstate',
      },
      {
        id: 'PostNumber',
        format: 'string',
        key: 'PostNumber',
      },
      {
        id: 'StreetAddress',
        format: 'string',
        key: 'StreetAddress',
      },
    ],
  },
  buildInfo: {
    title: 'G_BuildingActs',
    fieldsList: [
      {
        id: 'Approved',
        format: 'string',
        key: 'Approved',
      },
      {
        id: 'Used',
        format: 'string',
        key: 'Used',
      },
      {
        id: 'ParkingSpacesPermitted',
        format: 'string',
        key: 'ParkingSpacesPermitted',
      },
    ],
  },
  sizeInfo: {
    title: 'G_SizeInformation',
    fieldsList: [
      {
        id: 'SquareMeters',
        format: 'string',
        key: 'SquareMeters',
      },
    ],
  },
};
